import React from 'react';
import { Helmet } from 'react-helmet';

export default function PageMetaData({
  title,
  description,
  author,
  imageURL = '/LanguageGroup.png',
  url = '',
  created,
  updated,
}) {
  const siteURL = 'https://languagelearninglibrary.com';
  const meta = [
    { name: 'author', content: author || 'Gary McCann' },
    { name: 'description', content: description },
    {
      name: 'robots',
      content:
        'follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large',
    },
    { property: 'og:local', content: 'en_US' },
    { property: 'og:type', content: 'article' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:url', content: siteURL + url },
    { property: 'og:site_name', content: 'Language Learning Library' },
    { property: 'article:tag', content: 'multiple languages' },
    { property: 'article:tag', content: 'review' },
    { property: 'article:section', content: 'Review' },
    { property: 'og:updated_time', content: updated },
    { property: 'fb:app_id', content: '505023160785682' },
    {
      property: 'og:image',
      content: siteURL + imageURL,
    },
    {
      property: 'og:image:secure_url',
      content: siteURL + imageURL,
    },
    { property: 'og:image:width', content: '1024' },
    { property: 'og:image:height', content: '576' },
    {
      property: 'og:image:alt',
      content: 'A review of ' + title + ' with a screenshot of the website',
    },
    { property: 'og:image:type', content: 'image/png' },
    { property: 'article:published_time', content: created },
    { property: 'article:m`odified_time', content: updated },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: siteURL + imageURL },
  ];
  return (
    <Helmet title={`${title} | Language Learning Library`} meta={meta}>
      <link rel='canonical' href={siteURL + url} />
    </Helmet>
  );
}
